<template>
  <div>
    The space object report displays additional results related to the space
    object when no maneuver was observed. Currently only the ballistic
    coefficient is calculated using the SP_ephemerides. The convention used for
    the computation of the mean balistic coefficient is the following :
    <br />
    <katex-element
      expression="\frac{da}{dt} = - B \rho n a^{2} \left(1 - \frac{\omega_e}{n} \cos(i) \right)^{2}"
    />
    <br />
    where <katex-element expression="B" /> denotes the balistic coefficient.
    <br />
    <br />
    The date of the used file for the calculations is also displayed as well as
    the standard deviation of the resulted coefficient with respect to the one
    calculated previously.
    <br />
    <br />
    The advanced balistic analysis is computed only if there are less than 5
    balistic segments to analyse, otherwise, the simplified analysis is
    preferred.
  </div>
</template>

<script>
export default {
  name: 'tooltipSpaceObjectReport'
}
</script>
